export class MenuModule {

	constructor() {
		this.menuButton = document.querySelector("[data-menu-trigger]");
		this.menu = document.querySelector("[data-menu-action]");
		this.siteHeader = document.querySelector(".site-header");
		this.body = document.querySelector("body");

		this.submenuButtons = document.querySelectorAll("[data-submenu-button]");

		this.minSizeForSubmenuClosing = 1201;
		this.boundCloseSubmenusOnOutsideClick = this.closeSubmenusOnOutsideClick.bind(this);

		this.init();
	}

	init() {
		this.menuButton.addEventListener('click', (e) => this.toggleMenu(e));

		if (this.submenuButtons.length) {
			for (let i = 0; i < this.submenuButtons.length; i++) {
				this.submenuButtons[i].addEventListener('click', (e) => this.toggleSubmenu(e));
			}
		}
	}

	closeAllSubmenus() {
		const shouldCloseSubmenus = window.innerWidth >= this.minSizeForSubmenuClosing && this.submenuButtons.length;

		if (shouldCloseSubmenus) {
			for (let i = 0; i < this.submenuButtons.length; i++) {
				this.submenuButtons[i].parentNode.classList.remove('active');
				this.submenuButtons[i].setAttribute('aria-expanded', false);
			}
		}
	}

	closeSubmenusOnOutsideClick(e) {
		const isWithinMainMenuItem = e.target.closest('.main-navigation__menu-item');

		if (!isWithinMainMenuItem) {
			this.closeAllSubmenus();
			document.body.removeEventListener('click', this.boundCloseSubmenusOnOutsideClick);
		}
	} 

	toggleSubmenu(e) {
		// remove eventual active eventlistener
		document.body.removeEventListener('click', this.boundCloseSubmenusOnOutsideClick);

		// get submenus except self
		const submenuButtonsToClose = [...this.submenuButtons].filter((item) => item !== e.currentTarget);

		// close all submenus except self if desktop menu
		if (window.innerWidth >= this.minSizeForSubmenuClosing) {
			for (let i = 0; i < submenuButtonsToClose.length; i++) {
				submenuButtonsToClose[i].parentNode.classList.remove('active');
				submenuButtonsToClose[i].setAttribute('aria-expanded', false);
			}
		}

		// target parentli from submenubutton
		const parentLi = e.currentTarget.parentNode;
		parentLi.classList.toggle('active');

		// target submenubutton
		e.currentTarget.setAttribute('aria-expanded', parentLi.classList.contains('active'));
		
		const isExpanded = e.currentTarget.getAttribute('aria-expanded');

		if (isExpanded) {
			document.body.addEventListener('click', this.boundCloseSubmenusOnOutsideClick);
		}
	}

	toggleMenu(e) {
		this.menu.classList.toggle('active');
		this.siteHeader.classList.toggle('active');
		this.menuButton.classList.toggle('active');
		this.body.classList.toggle('no-scroll');

		this.menuButton.setAttribute('aria-expanded', this.menuButton.classList.contains('active'));
	}

	hasOpenMenu() {
		return this.menu.hasClass('active');
	}

}
